// extracted by mini-css-extract-plugin
export default {"corner-nav-group":"CornerNavGroup_corner-nav-group__tr+ef","small":"CornerNavGroup_small__AvqlH"};